import {useMemo} from 'react';
import {SxProps, Theme} from '@mui/material/styles';
import {FlatSelectDropdown, Option} from '../flat-select-dropdown/flat-select-dropdown';
import {formatTimeZoneLabel, sortTimeZonesByOffset, timeZones} from '../../utils/data';

export interface FlatTimeZoneSelectProps {
  label?: string;
  placeholder?: string;
  required?: boolean;
  value?: string;
  onChange: (timeZone?: string) => void;
  disabled?: boolean;
  clearable?: boolean;
  sx?: SxProps<Theme>;
}

export const FlatTimeZoneSelect = ({
  label,
  placeholder,
  required,
  value,
  onChange,
  disabled,
  clearable = false,
  sx,
}: FlatTimeZoneSelectProps) => {
  const options: Option[] = useMemo(() => {
    // Keep the current value selectable even when the browser does not list it
    const available = value && !timeZones.includes(value) ? [value, ...timeZones] : timeZones;

    const now = new Date();

    return sortTimeZonesByOffset(available, now).map((timeZone) => ({
      key: timeZone,
      label: formatTimeZoneLabel(timeZone, now),
    }));
  }, [value]);

  return (
    <FlatSelectDropdown
      label={label}
      placeholder={placeholder}
      required={required}
      value={value ? {key: value, label: formatTimeZoneLabel(value)} : undefined}
      options={options}
      onChange={(e) => onChange(e.key || undefined)}
      disabled={disabled}
      clearable={clearable}
      sx={sx}
    />
  );
};
